<template>
  <div>
    <QuickThinkHead></QuickThinkHead>
    <instructions></instructions>
    <Download></Download>
<Footer></Footer>

  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    greet: () => {
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/MainComponents/HomePage.vue